"use client";

import { useEffect, useState } from "react";
import Headline from "@/partials/elements/Headline";
import BenefitsCard from "./BenefitsCard/BenefitsCard";

import "./benefits.css";

const Benefits = ({ benefits }) => {
  const [showModal, setShowModal] = useState(false);
  const [modalId, setModalId] = useState(null);
  const [displayedBenefits, setDisplayedBenefits] = useState([]);

  useEffect(() => {
    setDisplayedBenefits(benefits?.slice(0, 3));
  }, [benefits]);

  const handleClose = () => {
    setShowModal(false);
    setModalId(null);
  };

  const handleModalOpen = (id) => {
    setModalId(id);
    setShowModal(true);
  };

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [showModal]);

  return (
    <div className="container mx-auto my-6">
      <Headline
        text="Benefits We Provide"
        extraClass={"text-center py-4 mb-4"}
      />
      <BenefitsCard
        showModal={showModal}
        displayedBenefits={displayedBenefits}
        benefits={displayedBenefits}
        handleModalOpen={handleModalOpen}
        handleModalClose={handleClose}
        modalId={modalId}
      />
    </div>
  );
};

export default Benefits;
